var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcPauseBottom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 3.75C11.0254 3.75 3.75 11.0254 3.75 20C3.75 28.9746 11.0254 36.25 20 36.25C28.9746 36.25 36.25 28.9746 36.25 20C36.25 11.0254 28.9746 3.75 20 3.75Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7188 15.7813C16.7188 15.5224 16.9286 15.3125 17.1875 15.3125H18.125C18.3839 15.3125 18.5938 15.5224 18.5938 15.7813V24.2188C18.5938 24.4776 18.3839 24.6875 18.125 24.6875H17.1875C17.0632 24.6875 16.944 24.6381 16.856 24.5502C16.7681 24.4623 16.7188 24.3431 16.7188 24.2188L16.7188 15.7813ZM21.4063 15.7813C21.4063 15.5224 21.6161 15.3125 21.875 15.3125H22.8125C22.9368 15.3125 23.0561 15.3619 23.144 15.4498C23.2319 15.5377 23.2813 15.6569 23.2813 15.7813L23.2813 24.2188C23.2813 24.4776 23.0714 24.6875 22.8125 24.6875H21.875C21.6161 24.6875 21.4063 24.4776 21.4063 24.2188V15.7813Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPauseBottom);
export default __webpack_public_path__ + "static/media/ic_pause_bottom.4059b294d0915d3b5c141a34b0950579.svg";
export { ForwardRef as ReactComponent };